import { useQuery } from '@apollo/client'
import { useMemo } from 'react'

import { GQL_QUERY_ALL_BANNERS } from '@entities/Banners/model/queries'

import { IMAGE_SIZES, ImageSize } from '@shared/contants'
import { AllBannersQuery, AllBannersQueryVariables } from '@shared/generated'


type useSingleBannerParams = {
  id?: string;
  style?: ImageSize;
  mobileSlideStyle?: ImageSize;
  fetchPolicy?: 'cache-and-network' | 'network-only' | 'cache-first' | 'no-cache';
}

export function useSingleBanner ({
  id,
  style = IMAGE_SIZES.HERO,
  mobileSlideStyle = IMAGE_SIZES.MOBILE,
  fetchPolicy = 'cache-and-network',
}: useSingleBannerParams) {
  const { data, loading, error } = useQuery<AllBannersQuery, AllBannersQueryVariables>(
    GQL_QUERY_ALL_BANNERS,
    {
      variables: {
        pager: { limit: 1, page: 1 },
        style,
        bannerMobileSlideStyle2: mobileSlideStyle,
        filter: {
          fields: [ 'id' ],
          op: 'eq',
          value: [ id ]
        },
      },
      fetchPolicy,
      skip: !id
    }
  )

  const banner = useMemo(() => data?.allBanners?.edges?.[0] ?? null, [ data ])

  return { 
    data, 
    banner,
    loading, 
    error
  }
}